import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import {
  TranslateService,
  TranslatePipe,
  TranslateDirective,
  LangChangeEvent
} from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [TranslatePipe, TranslateDirective, FormsModule, ReactiveFormsModule,],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.css'
})
export class PaginatorComponent implements OnInit {

  @Input() control!: string;

  @Input() isStart!: boolean;

  @Input() isEnd!: boolean;

  @Input() isControlPageSize!: boolean;

  @Input() currentPage!: number;

  @Input() totalPages!: number;

  @Input() numberRecord!: number;

  @Input() sizePage!: number;

  @Output() pageChanged = new EventEmitter<number>();

  @Output() controlEmited = new EventEmitter<string>();

  @Output() pageSizaChanged = new EventEmitter<number>();


  constructor(private sharedService: SharedService, private translateService: TranslateService) {

  }

  filterPaginator = new FormGroup({
    pageSize: new FormControl(10), // Control para el input "Estado"
  });

  ngOnInit(): void {
    this.getPageRange();
    this.controlEmited.emit(this.control)
    this.pageChanged.emit(this.currentPage);
    this.pageSizaChanged.emit(this.sizePage);
  }

  /**
     * Función encargada de generar el rango del paginador
     * @returns 
     */
  getPageRange(): number[] {
    let start = Math.max(1, this.currentPage - Math.floor(this.sizePage / 2));
    let end = Math.min(this.totalPages, start + this.sizePage - 1);
    const rango = [];
    if (this.sizePage > 0) {
      for (let i = start; i <= end; i++) {
        rango.push(i);
      }
    }
    return rango;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.controlEmited.emit(this.control)
      localStorage.setItem('currentPage', this.control);
      this.sharedService.changePage(this.currentPage);
    }
  }

  goToPreviousPage(): void {
    this.goToPage(this.currentPage - 1);
  }

  goToNextPage(): void {
    this.goToPage(this.currentPage + 1);
  }

  /**
     * Función encargada de obtener la pagina al que se ha pulsado para cargar de nuevo el listado de las actividades
     * @param pagina 
     */
  changePage(page: number): void {
    this.currentPage = page;
    // Emitimos el cambio de la pagina para que lo detecte el componente padre, en este caso, usuarios.components.html
    localStorage.setItem('currentPage', this.control);
    this.sharedService.changePage(page);
  }

  changeSize() {
    console.log(this.control)
    console.log('entro1')
    this.sizePage = this.filterPaginator.get('pageSize')?.value || 5
    this.sharedService.changeSize(this.sizePage);
  }

}
